import type { ExcelType, SignatureType } from '@module/apis/client-side/live/type';
import { create, type StateCreator } from 'zustand';

export interface SponState {
  type?: string;
  heart?: number | string;
  count?: number | string;
  start?: number | string;
  end?: number | string;
  continueTime?: number;
  total?: number;
  message?: string;
  excelType?: ExcelType;
  excelBj?: number;
  signature?: SignatureType;
}

interface AutoSponState {
  isSponTriggered: boolean;
  sponState?: SponState;
  startSpon: (newSponState: SponState) => void;
  resetIsSponTriggered: () => void;
}

const store: StateCreator<AutoSponState, [], [], AutoSponState> = (set) => ({
  isSponTriggered: false,
  sponState: undefined,
  startSpon: (sponState: Partial<SponState>) =>
    set((state) => ({ ...state, isSponTriggered: true, sponState: { ...sponState } })),
  resetIsSponTriggered: () => set((state) => ({ ...state, isSponTriggered: false })),
});

const useAutoSponStore = create<AutoSponState>()(store);

export default useAutoSponStore;
